import React from 'react'
import { Typography, Box } from '@mui/material'

const UserManagementPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        User Management
      </Typography>
      <Typography variant="body1">
        This page will allow super admins to manage users, companies, and departments.
      </Typography>
    </Box>
  )
}

export default UserManagementPage
